/*
 * Filas de recomendación de Connectif en la home personalizada.
 *
 *   1. Corrige las imágenes: Connectif sirve cuadrado (crop=center) y las
 *      tarjetas son 3:4, así que se reescribe el src del CDN quitando
 *      crop/height y dejando solo width. Nunca reduce.
 *   2. Envía view_item_list / select_item a GA4 con un item_list_name por
 *      fila, para poder decidir qué fila merece su espacio en la portada.
 *
 * Connectif pinta las tarjetas de forma asíncrona -> MutationObserver.
 */
(function () {
  /* Descendiente, no hijo directo: cada slot va dentro de su <section> con título */
  var rows = document.querySelectorAll('.cn-home-rows [data-cn-slot]');
  if (!rows.length) return;

  var TARGET_WIDTH = 900;
  var MIN_OK       = 800;

  /* ---------- 1. Imágenes: quitar el recorte cuadrado del CDN ---------- */
  function upgrade(img) {
    var src = img.getAttribute('src') || '';
    if (!src || src === img.dataset.cnSrc) return;
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return;

    try {
      var url = new URL(src, location.origin);
      var w = parseInt(url.searchParams.get('width') || '0', 10);
      var cropped = url.searchParams.has('crop') || url.searchParams.has('height');
      if (w >= MIN_OK && !cropped) return;

      url.searchParams.delete('height');
      url.searchParams.delete('crop');
      url.searchParams.set('width', Math.max(w, TARGET_WIDTH));

      var next = url.toString();
      if (next === src) return;
      img.dataset.cnSrc = next;
      img.removeAttribute('srcset');
      img.setAttribute('src', next);
    } catch (e) {}
  }

  /* ---------- 2. Leer las tarjetas que pinta Connectif ---------- */
  function textOf(el, sel) {
    var n = el.querySelector(sel);
    return n ? n.textContent.trim() : '';
  }

  function parseCards(row) {
    var cards = row.querySelectorAll('product-card');
    var items = [];

    for (var i = 0; i < cards.length; i++) {
      var link = cards[i].querySelector('a[href]');
      var href = link ? link.getAttribute('href') : '';
      var handle = (href.split('?')[0].split('/products/')[1] || '').replace(/\/$/, '');

      /* "325,00 €" -> 325.00 (punto de millar, coma decimal) */
      var raw = textOf(cards[i], '.cn_element_products_2_unit_price .amount');
      var price = parseFloat(raw.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.'));

      items.push({
        item_id:        handle || ('pos-' + (i + 1)),
        item_name:      textOf(cards[i], '.cn_element_products_2_name'),
        item_brand:     textOf(cards[i], '.cn_element_products_2_brand'),
        price:          isNaN(price) ? undefined : price,
        item_list_name: row.dataset.cnList,
        index:          i + 1
      });
    }

    return items;
  }

  /* ---------- 3. GA4 (GTM si existe, si no gtag) ---------- */
  function track(name, payload) {
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: name, ecommerce: payload });
    } else if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
    }
  }

  /* Impresión: solo cuando la fila es visible Y ya tiene tarjetas.
     Sin la doble condición se contarían impresiones de filas vacías. */
  function attempt(row) {
    if (row.dataset.cnTracked || !row.dataset.cnVisible) return;
    var items = parseCards(row);
    if (!items.length) return;
    row.dataset.cnTracked = '1';
    track('view_item_list', { item_list_name: row.dataset.cnList, items: items });
  }

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      entries[i].target.dataset.cnVisible = '1';
      attempt(entries[i].target);
    }
  }, { threshold: 0.3 });

  /* ---------- 4. Arranque por fila ---------- */
  for (var r = 0; r < rows.length; r++) {
    (function (row) {
      function scan() {
        var imgs = row.querySelectorAll('img');
        for (var i = 0; i < imgs.length; i++) upgrade(imgs[i]);
        attempt(row);
      }

      new MutationObserver(scan).observe(row, {
        childList: true, subtree: true, attributes: true, attributeFilter: ['src']
      });
      io.observe(row);
      scan();
    })(rows[r]);
  }

  /* ---------- 5. Click en tarjeta ---------- */
  var container = document.querySelector('.cn-home-rows');
  if (!container) return;

  container.addEventListener('click', function (ev) {
    if (!ev.target.closest) return;
    var card = ev.target.closest('product-card');
    if (!card) return;
    var row = card.closest('[data-cn-list]');
    if (!row) return;

    var cards = row.querySelectorAll('product-card');
    var idx = Array.prototype.indexOf.call(cards, card);
    var items = parseCards(row);
    if (idx < 0 || !items[idx]) return;

    track('select_item', { item_list_name: row.dataset.cnList, items: [items[idx]] });
  });
})();
